import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { setLogoutHandler } from "../lib/api";
import Header from "../components/Header";
import ChangePasswordModal from "../components/ChangePasswordModal";
import AuthPage from "../pages/AuthPage";
import LeadMakerDashboard from "../pages/LeadMakerDashboard";
import AdminDashboard from "../pages/AdminDashboard";
import Products from "../pages/Products";
import Users from "../pages/Users";
import Analytics from "../pages/Analytics";

export default function AppShell() {
  const { token, user, requiresPasswordChange, login, logout, clearPasswordChangeRequirement } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Register logout handler for axios interceptor
  useEffect(() => {
    setLogoutHandler(logout);
  }, [logout]);

  useEffect(() => {
    if (user?.role === 'admin' && location.pathname === '/') {
      navigate('/admin');
    } else if (user?.role === 'leadmaker' && location.pathname !== '/') {
      navigate('/');
    }
  }, [user, location.pathname, navigate]);

  if (!token || !user) return <AuthPage onLogin={login} />;

  const renderContent = () => {
    if (user.role === 'leadmaker') {
      return <LeadMakerDashboard token={token} user={user} />;
    }
    
    if (user.role === 'admin') {
      if (location.pathname === '/admin/products') {
        return <Products token={token} />;
      }
      if (location.pathname === '/admin/users') {
        return <Users token={token} />;
      }
      if (location.pathname === '/admin/analytics') {
        return <Analytics token={token} />;
      }
      return <AdminDashboard token={token} />;
    }
    
    return null;
  };

  const handlePasswordChangeComplete = (newToken, updatedUser) => {
    clearPasswordChangeRequirement();
    // Update state with new token and user without reload
    login(newToken, updatedUser, false);
  };

  return (
    <div>
      <ChangePasswordModal 
        isOpen={requiresPasswordChange} 
        token={token}
        onSubmit={handlePasswordChangeComplete} 
      />
      <Header user={user} onLogout={logout} />
      {renderContent()}
    </div>
  );
}

